module.exports = __webpack_public_path__ + "static/media/video-progress.391d83c8.png";